import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FormManagerService } from '@sim/form';
import { BaseFiltersComponent, FilterFieldsOptions } from '@ui/ui.module';

import { cardOA } from '@atmi/core/models';

/*
* https://v11.material.angular.io/components/select/overview
* use multi select and read 20-30 as string --> split and parse float then setup range values
* */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-card-oa-filters',
  styleUrls: ['./card-oa-filters.component.scss'],
  templateUrl: './card-oa-filters.component.html',
})
export class CardOaFiltersComponent extends BaseFiltersComponent<cardOA.CardOAFilter, FilterFieldsOptions<cardOA.CardOAFilter>> {
  constructor(
    protected readonly formManager: FormManagerService,
  ) {
    super(formManager, cardOA.CardOAFiltersMeta);
  }
}
